import * as i0 from '@angular/core';
import { Directive, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// IMPORTANT NOTIFICATION BADGE
class XpoBadgeImportantNotification {
}
XpoBadgeImportantNotification.ɵfac = function XpoBadgeImportantNotification_Factory(t) { return new (t || XpoBadgeImportantNotification)(); };
XpoBadgeImportantNotification.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeImportantNotification, selectors: [["", "xpo-badge-important-notification", ""], ["", "xpoBadgeImportantNotification", ""]], hostAttrs: [1, "xpo-Badge--important"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeImportantNotification, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-important-notification], [xpoBadgeImportantNotification] ',
                host: {
                    class: 'xpo-Badge--important',
                },
            }]
    }], null, null); })();
// DOT BADGE
class XpoBadgeDotWarning {
}
XpoBadgeDotWarning.ɵfac = function XpoBadgeDotWarning_Factory(t) { return new (t || XpoBadgeDotWarning)(); };
XpoBadgeDotWarning.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeDotWarning, selectors: [["", "xpo-badge-dot-warning", ""], ["", "xpoBadgeDotWarning", ""]], hostAttrs: [1, "xpo-BadgeDot", "xpo-BadgeDot--warning"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeDotWarning, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-dot-warning], [xpoBadgeDotWarning] ',
                host: {
                    class: 'xpo-BadgeDot xpo-BadgeDot--warning',
                },
            }]
    }], null, null); })();
class XpoBadgeDotSuccess {
}
XpoBadgeDotSuccess.ɵfac = function XpoBadgeDotSuccess_Factory(t) { return new (t || XpoBadgeDotSuccess)(); };
XpoBadgeDotSuccess.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeDotSuccess, selectors: [["", "xpo-badge-dot-success", ""], ["", "xpoBadgeDotSuccess", ""]], hostAttrs: [1, "xpo-BadgeDot", "xpo-BadgeDot--success"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeDotSuccess, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-dot-success], [xpoBadgeDotSuccess] ',
                host: {
                    class: 'xpo-BadgeDot xpo-BadgeDot--success',
                },
            }]
    }], null, null); })();
class XpoBadgeDotInfo {
}
XpoBadgeDotInfo.ɵfac = function XpoBadgeDotInfo_Factory(t) { return new (t || XpoBadgeDotInfo)(); };
XpoBadgeDotInfo.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeDotInfo, selectors: [["", "xpo-badge-dot-info", ""], ["", "xpoBadgeDotInfo", ""]], hostAttrs: [1, "xpo-BadgeDot", "xpo-BadgeDot--info"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeDotInfo, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-dot-info], [xpoBadgeDotInfo] ',
                host: {
                    class: 'xpo-BadgeDot xpo-BadgeDot--info',
                },
            }]
    }], null, null); })();
class XpoBadgeDotImportant {
}
XpoBadgeDotImportant.ɵfac = function XpoBadgeDotImportant_Factory(t) { return new (t || XpoBadgeDotImportant)(); };
XpoBadgeDotImportant.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeDotImportant, selectors: [["", "xpo-badge-dot-important", ""], ["", "xpoBadgeDotImportant", ""]], hostAttrs: [1, "xpo-BadgeDot", "xpo-BadgeDot--important"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeDotImportant, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-dot-important], [xpoBadgeDotImportant] ',
                host: {
                    class: 'xpo-BadgeDot xpo-BadgeDot--important',
                },
            }]
    }], null, null); })();

class XpoBadgeModule {
}
XpoBadgeModule.ɵfac = function XpoBadgeModule_Factory(t) { return new (t || XpoBadgeModule)(); };
XpoBadgeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoBadgeModule });
XpoBadgeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    XpoBadgeDotWarning,
                    XpoBadgeDotImportant,
                    XpoBadgeDotInfo,
                    XpoBadgeDotSuccess,
                    XpoBadgeImportantNotification,
                ],
                exports: [
                    XpoBadgeDotWarning,
                    XpoBadgeDotImportant,
                    XpoBadgeDotInfo,
                    XpoBadgeDotSuccess,
                    XpoBadgeImportantNotification,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoBadgeModule, { declarations: [XpoBadgeDotWarning,
        XpoBadgeDotImportant,
        XpoBadgeDotInfo,
        XpoBadgeDotSuccess,
        XpoBadgeImportantNotification], imports: [CommonModule], exports: [XpoBadgeDotWarning,
        XpoBadgeDotImportant,
        XpoBadgeDotInfo,
        XpoBadgeDotSuccess,
        XpoBadgeImportantNotification] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoBadgeDotImportant, XpoBadgeDotInfo, XpoBadgeDotSuccess, XpoBadgeDotWarning, XpoBadgeImportantNotification, XpoBadgeModule };
